import { render, staticRenderFns } from "./AppointmentAlert.vue?vue&type=template&id=78d4dbfc&scoped=true&"
import script from "./AppointmentAlert.vue?vue&type=script&lang=js&"
export * from "./AppointmentAlert.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentAlert.vue?vue&type=style&index=0&id=78d4dbfc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d4dbfc",
  null
  
)

export default component.exports